export default __webpack_public_path__ + "static/media/right_big.f9cc59e0.svg";